module.exports = [
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "1999-2001",
    "Rate": 819.43
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "2002-2004",
    "Rate": 1010.67
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "2005-2007",
    "Rate": 895.4
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "2008-2010",
    "Rate": 709.23
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "2011-2013",
    "Rate": 772.37
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "2014-2016",
    "Rate": 654.7
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "Metro New Orleans",
    "Year": "2017-2018",
    "Rate": 573.2
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "1999-2001",
    "Rate": 719.9
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "2002-2004",
    "Rate": 703.43
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "2005-2007",
    "Rate": 706.17
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "2008-2010",
    "Rate": 654
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "2011-2013",
    "Rate": 598.03
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "2014-2016",
    "Rate": 587
  },
  {
    "AgeGroup": "< 1 year",
    "Geography": "United States",
    "Year": "2017-2018",
    "Rate": 562.4
  }
]
